import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "main pb-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "container-fluid top-bar" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "container mt-5" }, [
  /*#__PURE__*/_createElementVNode("section", { class: "top-column column" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "welcome-user" }, "Créer mon portefeuille")
  ])
], -1)
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "columns id-tablet" }
const _hoisted_6 = { class: "column" }
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "card-content" }
const _hoisted_9 = { class: "tabs is-toggle is-toggle-rounded" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "container" }
const _hoisted_12 = { class: "columns is-tablet" }
const _hoisted_13 = { class: "column" }
const _hoisted_14 = { class: "card" }
const _hoisted_15 = { class: "card-content" }
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "notification is-danger" }, " Attention, ce mot de passe n'est pas récupérable, alors veillez à le garder dans un endroit sûr et accessible. ", -1)
const _hoisted_19 = { class: "column" }
const _hoisted_20 = { class: "card" }
const _hoisted_21 = { class: "card-content" }
const _hoisted_22 = { class: "field" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Mot de passe", -1)
const _hoisted_24 = { class: "control has-icons-left has-icons-right" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-key" })
], -1)
const _hoisted_26 = {
  key: 0,
  class: "icon is-small is-right"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle" }, null, -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_30 = { class: "field" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Confirmation du mot de passe", -1)
const _hoisted_32 = { class: "control has-icons-left has-icons-right" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-key" })
], -1)
const _hoisted_34 = {
  key: 0,
  class: "icon is-small is-right"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle" }, null, -1)
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_38 = {
  key: 0,
  class: "field"
}
const _hoisted_39 = { class: "control" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unconfiguredBackends, (backend, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: _normalizeClass({
                        'is-active': _ctx.form.accountBackend === backend,
                      }),
                      onClick: ($event: any) => (_ctx.form.accountBackend = backend)
                    }, [
                      _createElementVNode("a", null, [
                        _createElementVNode("span", null, _toDisplayString(backend), 1)
                      ])
                    ], 10, _hoisted_10))
                  }), 256))
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("p", _hoisted_16, " Veuillez renseigner un mot de passe (et le confirmer) pour votre nouveau compte " + _toDisplayString(_ctx.form.accountBackend) + ". ", 1),
              _createElementVNode("p", _hoisted_17, " Ce mot de passe est différent de votre mot de passe Monujo, il concerne uniquement votre portefeuille " + _toDisplayString(_ctx.form.accountBackend) + ". ", 1),
              _hoisted_18
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  _withDirectives(_createElementVNode("input", {
                    class: _normalizeClass(["input", {
                      'is-danger': _ctx.hasError('accountPassword'),
                      'is-success':
                        !_ctx.hasError('accountPassword') &&
                        _ctx.form.accountPassword.length > 1,
                    }]),
                    autocomplete: "new-password",
                    type: "password",
                    placeholder: "Mot de passe",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.accountPassword) = $event))
                  }, null, 2), [
                    [_vModelText, _ctx.form.accountPassword]
                  ]),
                  _hoisted_25,
                  (_ctx.hasError('accountPassword'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_26, _hoisted_28))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.hasError('accountPassword'))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_29, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.form.errors.accountPassword, (err) => {
                        return (_openBlock(), _createElementBlock("div", null, _toDisplayString(err), 1))
                      }), 256))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, [
                  _withDirectives(_createElementVNode("input", {
                    onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.createUserAccount && _ctx.createUserAccount(...args)), ["enter"])),
                    class: _normalizeClass(["input", {
                      'is-danger': _ctx.hasError('accountPasswordConfirm'),
                      'is-success':
                        !_ctx.hasError('accountPasswordConfirm') &&
                        _ctx.form.accountPasswordConfirm.length > 1,
                    }]),
                    autocomplete: "new-password",
                    type: "password",
                    placeholder: "Confirmation du mot de passe",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.accountPasswordConfirm) = $event))
                  }, null, 34), [
                    [_vModelText, _ctx.form.accountPasswordConfirm]
                  ]),
                  _hoisted_33,
                  (_ctx.hasError('accountPasswordConfirm'))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_34, _hoisted_36))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.hasError('accountPasswordConfirm'))
                  ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(_ctx.form.errors.accountPasswordConfirm[0]), 1))
                  : _createCommentVNode("", true)
              ]),
              (!_ctx.hasFieldErrors)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("button", {
                        class: "button is-primary",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.createUserAccount()))
                      }, " Créer mon portefeuille ")
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ]))
}